import { cn } from '@utils/helpers'

export const DropdownItem = ({
  children,
  onClick,
  active = false,
  className = '',
  ...props
}) => {
  return (
    <button
      onClick={onClick}
      className={cn(
        'w-full text-left px-4 py-2 text-sm transition-colors hover:bg-slate-50',
        active ? 'bg-primary-50 text-primary-800 font-medium' : 'text-slate-700',
        className
      )}
      {...props}
    >
      {children}
    </button>
  )
}
